import "./Coupon.scss"

export type Coupon = {
    CompanyID: string;
    Description: string;
    ExpirationMonth: string;
    ExpirationDay: string;
    ExpirationYear: string;
    Location: string;
    CouponID: string;
    Sponsor: string;
    Click: string;
    HonorY: string;
    HonorN: string;
    Name: string;
    CityID: string;
    Category: string;
    ChainID: string;
    CityName: string;
    Logo: string;
    Expiration: string;
};  

const CouponComponent = ({coupon}) => {

    return <div class="coupon-container" onClick={() => window.open(coupon.Location, "_blank")}>
        <div class="coupon-header">
            {coupon.Logo && coupon.Logo !== "" ?
                <img className={"coupon-logo"} src={"https://www.companyrank.com/logos/" + coupon.Logo} alt={coupon.Name || "coupon"} />
                : <h2 className={"coupon-title"}>{coupon.Name}</h2>}
        </div>

        <div class={"coupon-description"}>
            {coupon.Description}
        </div>

        <a class="coupon-link" target={"_blank"}>
            Claim Deal!
        </a>
    </div>
};

export default CouponComponent;